/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { Axios } from 'axios'
import { getCrawlerAPI } from './api-generated/api'
import { MessageSeverity, useAppStore } from '@/store'
import Cookies from 'js-cookie'

export enum AvailableLangs {
  ar = 'ar',
  az = 'az',
  id = 'id',
  bg = 'bg',
  cs = 'cs',
  da = 'da',
  de = 'de',
  et = 'et',
  en = 'en',
  es = 'es',
  fr = 'fr',
  ka = 'ka',
  el = 'el',
  he = 'he',
  hi = 'hi',
  hr = 'hr',
  it = 'it',
  kk = 'kk',
  ko = 'ko',
  lv = 'lv',
  lt = 'lt',
  hu = 'hu',
  nl = 'nl',
  no = 'no',
  pl = 'pl',
  pt = 'pt',
  ro = 'ro',
  ru = 'ru',
  sk = 'sk',
  sl = 'sl',
  sr = 'sr',
  sv = 'sv',
  tr = 'tr',
  uk = 'uk',
  vi = 'vi',
}

export enum Role {
  USER = 'USER',
  PREMIUM_USER = 'PREMIUM_USER',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
}

export const Config = {
  APP_NAME: 'CrawlHawk',
  SERVER: process.env.NEXT_PUBLIC_BACKEND_URL || `https://api.crawlhawk.com`,
  CONTENT_API:
    process.env.NEXT_PUBLIC_CONTENT_API_URL || `https://admin.crawlhawk.com`,
  RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || ``,
  FEATURES: {
    SIGNUP_ENABLED: true,
  },
  FALLBACK_LANG: 'en',
  AVAILABLE_LANGS: [
    AvailableLangs.ar,
    AvailableLangs.az,
    AvailableLangs.id,
    AvailableLangs.bg,
    AvailableLangs.cs,
    AvailableLangs.da,
    AvailableLangs.de,
    AvailableLangs.et,
    AvailableLangs.en,
    AvailableLangs.es,
    AvailableLangs.fr,
    AvailableLangs.ka,
    AvailableLangs.el,
    AvailableLangs.he,
    AvailableLangs.hi,
    AvailableLangs.hr,
    AvailableLangs.it,
    AvailableLangs.kk,
    AvailableLangs.ko,
    AvailableLangs.lv,
    AvailableLangs.lt,
    AvailableLangs.hu,
    AvailableLangs.nl,
    AvailableLangs.no,
    AvailableLangs.pl,
    AvailableLangs.pt,
    AvailableLangs.ro,
    AvailableLangs.ru,
    AvailableLangs.sk,
    AvailableLangs.sl,
    AvailableLangs.sr,
    AvailableLangs.sv,
    AvailableLangs.tr,
    AvailableLangs.uk,
    AvailableLangs.vi,
  ],
}

axios.defaults.baseURL = Config.SERVER

axios.interceptors.request.use(
  (request) => {
    const accessToken = Cookies.get('access_token')
    if (
      !request?.headers?.Authorization ||
      !request?.headers?.Authorization.toString().startsWith('Bearer')
    ) {
      request.headers.Authorization = `Bearer ${accessToken || ''}`
    }

    return request
  },
  (error) => {
    console.error(error)
    return Promise.reject(error)
  },
)

axios.interceptors.response.use(
  (response) => {
    // Edit response config
    return response
  },
  (error) => {
    const { setUser, setMessage: setError } = useAppStore.getState()
    const refreshToken = Cookies.get('refresh_token')
    if (error.response.status === 401 && refreshToken) {
      apiClient
        .getRefresh({
          headers: {
            Authorization: `Bearer ${refreshToken || ''}`,
          },
        })
        .then(({ data }: any) => {
          if (data && data?.accessToken && data?.refreshToken) {
            setUser({
              ...data,
            })
          }
        })
        .catch((err: any) => {
          console.error(err)
          setError({
            message: 'Session ended, please Sign In.',
            severity: MessageSeverity.ERROR,
          })

          setUser(null)
        })
    }

    return Promise.reject(error)
  },
)

export const apiClient = getCrawlerAPI()

export const contentApiClient = new Axios({
  headers: {
    Authorization: 'content-api-key',
    'Content-Type': 'application/json; charset=UTF-8',
  },
  baseURL: Config.CONTENT_API,
  timeout: 10000,
})
